import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

export interface EditRemarkDialogData {
  sessionId: string;
  currentRemark: string;
  childName: string;
}

@Component({
  selector: 'app-edit-remark-dialog',
  template: `
    <h2 mat-dialog-title>Edit Remark for {{data.childName}}</h2>
    <mat-dialog-content>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Remark by Counsellor</mat-label>
        <textarea
          matInput
          [formControl]="remarkControl"
          rows="6"
          placeholder="Enter your remark here..."
          maxlength="500"
        ></textarea>

        <mat-hint align="end">
          {{ remarkControl.value?.length || 0 }} / 500
        </mat-hint>
      </mat-form-field>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button
        mat-raised-button
        color="primary"
        (click)="onSave()"
        [disabled]="remarkControl.invalid || !remarkControl.value?.trim()"
      >
        Save Remark
      </button>

    </mat-dialog-actions>
  `,
  styles: [`
    .w-100 {
      width: 100%;
    }
    mat-form-field {
      margin-top: 10px;
    }
    mat-dialog-content {
      min-height: 150px;
    }
  `]
})
export class EditRemarkDialogComponent {
  // remarkControl = new FormControl('');
  remarkControl = new FormControl('', [Validators.maxLength(500)]);


  constructor(
    public dialogRef: MatDialogRef<EditRemarkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditRemarkDialogData
  ) {
    this.remarkControl = new FormControl(data.currentRemark || '', [
      Validators.maxLength(500)
    ]);
  }


  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const remark = this.remarkControl.value?.trim();
    if (remark) {
      this.dialogRef.close({ updated: true, remark });
    }
  }
}

